import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';

/**
 * Custom hook to determine the color based on a score.
 * @param {number} score - The score to evaluate (0-100).
 * @returns {string} - The color associated with the score.
 */
export const useThemeScoreColor = (score: number) => {
  const theme = useTheme();

  return useMemo(() => {
    if (score >= 80) {
      return theme.palette.success.main;
    } else if (score >= 50) {
      return theme.palette.warning.main;
    }
    return theme.palette.error.main;
  }, [
    score,
    theme.palette.success.main,
    theme.palette.warning.main,
    theme.palette.error.main,
  ]);
};
